import { getDriveImageVariants } from "../services/oneElectronicsApi";

// imgur sirve miniaturas agregando una letra al ID: m = 320px, l = 640px,
// h = 1024px. Las originales que sube el admin pesan hasta 1,3 MB; la "l" de la
// misma foto pesa ~50 KB. Las miniaturas salen en JPEG: la transparencia de las
// esquinas queda negra, invisible sobre el fondo oscuro de las tarjetas.
const IMGUR_RE = /^https?:\/\/i\.imgur\.com\/([A-Za-z0-9]{5,7})\.(png|jpe?g|gif|webp)$/i;

const imgurVariant = (id, ext, size) => `https://i.imgur.com/${id}${size}.${ext}`;

// Devuelve { src, srcSet } para usar en <img>. `size` elige la variante por
// defecto ("l" para tarjetas, "h" para la ficha). Si la URL no es de imgur ni
// de Drive, vuelve la original sin srcSet.
export const getImageVariants = (url, size = "l") => {
  if (!url || typeof url !== "string") return { src: url || "", srcSet: undefined };
  const imgur = url.trim().match(IMGUR_RE);
  if (imgur) {
    const [, id, ext] = imgur;
    return {
      src: imgurVariant(id, ext, size),
      srcSet: [
        `${imgurVariant(id, ext, "m")} 320w`,
        `${imgurVariant(id, ext, "l")} 640w`,
        `${imgurVariant(id, ext, "h")} 1024w`,
      ].join(", "),
    };
  }
  const drive = getDriveImageVariants(url);
  return { src: drive.src || url, srcSet: drive.srcSet || undefined };
};
